import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutCarrierSalesProfile } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierSalesProfile";

const viewCarrierSalesProfileURL = "lme/crm/CarrierSalesProfile?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "carrier_call_list_profile",
    screenName: "Carrier Sales Profile",
    navigateToUrl: viewCarrierSalesProfileURL
}

export class CarrierSalesProfile extends AutogenLayoutCarrierSalesProfile {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }
}